import http from "../../http";

export default {
  list(params) {
    return http.get("cmsservice/cms_solution/page", params);
  },
  listall(params) {
    return http.get("cmsservice/cms_solution/page/share", params);
  },
  info(id) {
    return http.get("cmsservice/cms_solution/info/" + id, {});
  },
  add(params) {
    return http.post("cmsservice/cms_solution/add", params);
  },
  update(params) {
    return http.post("cmsservice/cms_solution/update", params);
  },
  //修改状态，上架和下架
  status(params) {
    return http.get("cmsservice/cms_solution/status", params);
  },
  //置顶
  top(params) {
    return http.get("cmsservice/cms_solution/top", params);
  },
  delete(params) {
    return http.post("cmsservice/cms_solution/delete", params);
  },
  type: {
    tree(params) {
      return http.get("cmsservice/solutionSort/tree", params);
    },
    add(params) {
      return http.post("cmsservice/solutionSort/add", params);
    },
    update(params) {
      return http.put("cmsservice/solutionSort/update", params);
    },
    del(id) {
      return http.delete("cmsservice/solutionSort/del/" + id, {});
    }
  }
};
